export default __webpack_public_path__ + "static/media/send.5ed973e5.svg";